import React, {useState} from 'react';
import {r} from "@/utils/responsive";
import TextType from "@/components/TextType";
import ButtonMain from "@/components/ButtonMain";
import buttonEnd from "@/assets/img/end_button.png";
import ButtonSpan from "@/components/ButtonSpan";
import ShortcutText from "@/components/ShortcutText";
import {useNav} from "@/hooks/useNav";
import {motion} from "motion/react"
import ShortcutReforge from "@/components/ShortcutReforge";
import {useShortcuts} from "@/hooks/useShortcuts";

interface EndLayerProps extends React.HTMLAttributes<HTMLDivElement> {
}

const EndLayer: React.FC<EndLayerProps> = ({className, ...props}) => {
    const [isTypingParagraph1, setIsTypingParagraph1] = useState<boolean>(true);
    const [isTypingParagraph2, setIsTypingParagraph2] = useState<boolean>(true);
    const [isTypingParagraph3, setIsTypingParagraph3] = useState<boolean>(true);
    const {navigateToSection} = useNav()

    useShortcuts({
        onEnter: () => navigateToSection('share'),
        enabledSections: ['end']
    });

    return (
        <div
            {...props}
            style={{
                position: 'fixed',
                top: 0,
                right: 0,
                height: '100dvh',
                width: r.vmax(900),
                background: 'linear-gradient(270.54deg, rgba(0, 26, 92, 0.7) 66.09%, rgba(0, 26, 92, 0) 97.89%)'
            }}
        >
            <div style={{
                position: "absolute",
                top: r.vmax(150),
                left: r.vmax(194),
                display: 'flex',
                flexDirection: 'column',
                gap: r.vmax(48),
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: r.vmax(32),
                    letterSpacing: r.vmax(-0.5),
                }}>
                    <TextType
                        showCursor={isTypingParagraph1}
                        style={{
                            whiteSpace: "pre-wrap",
                            color: "rgba(255, 255, 255, 1)",
                            fontSize: r.vmax(48),
                            lineHeight: r.vmax(52),
                        }}
                        text={[
                            `Баланс восстановлен! \nСервисы стабильны. Поды \nработают. Ноды дышат ровно.`,
                        ]}
                        onAnimationComplete={() => setIsTypingParagraph1(false)}
                    />
                    {!isTypingParagraph1 && (
                        <TextType
                            showCursor={isTypingParagraph2}
                            style={{

                                whiteSpace: "pre-wrap",
                                color: "rgba(255, 255, 255, 1)",
                                fontSize: r.vmax(48),
                                lineHeight: r.vmax(52),
                            }}
                            text={[
                                `Kubernetes® восстановлен.\nВы победили сбои.`,
                            ]}
                            onAnimationComplete={() => setIsTypingParagraph2(false)}
                        />
                    )}
                    {!isTypingParagraph2 && (
                        <TextType
                            showCursor={isTypingParagraph3}
                            style={{

                                whiteSpace: "pre-wrap",
                                color: "rgba(255, 255, 255, 1)",
                                fontSize: r.vmax(48),
                                lineHeight: r.vmax(52),
                            }}
                            text={[
                                `Chaos Monster, некогда\nвселявший ужас в сердца\nмикросервисов, больше не\nправит хаосом.`,
                            ]}
                            onAnimationComplete={() => setIsTypingParagraph3(false)}
                        />
                    )}
                </div>
                <motion.div
                    initial={{y: 20, opacity: 0}}
                    animate={{y: isTypingParagraph3 ? 20 : 0, opacity: isTypingParagraph3 ? 0 : 1}}
                    transition={{duration: 0.6, ease: "easeOut"}}
                >
                    <ButtonMain width={668} height={140} glowWidth={747} glowHeight={220} glowTop={-30}
                                glowImage={buttonEnd}
                                onClick={() => navigateToSection('share')}>
                        <ButtonSpan>kubectl victory --all-namespaces</ButtonSpan>
                        <ShortcutReforge isLarge>ENTER</ShortcutReforge>
                    </ButtonMain>
                </motion.div>
            </div>
        </div>
    );
};

export default EndLayer;
